<template>
  <LoadingScreen :caption="'Static Entity Analysis...'" v-if="!isInitialized" />
  <router-view v-else></router-view>
</template>

<script>
import LoadingScreen from "@/components/modals/LoadingScreen";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    LoadingScreen,
  },
  computed: {
    ...mapGetters("StaticEntity", ["isInitialized"]),
    ...mapGetters("Entities", ["getStaticEntities"]),
  },
  methods: {
    ...mapActions("StaticEntity", [
      "fetchConsoles",
      "initializeConsole",
      // "initializeEditor",
      // "initializeViewer",
      "fetchStaticEntityList",
      "reset",
      "setStaticEntityId",
    ]),
    ...mapActions("Entities", [
      "fetchEntities",
      "fetchStaticEntities",
      "fetchEntityEvents",
    ]),

    ...mapActions("Map", ["fetchCities"]),
    initialize({ params, queries }) {
      if (queries && queries.id) {
        if (params.mode === "view")
          this.initializeConsole({ consoleId: queries.id, mode: "VIEW" });
        else if (params.mode === "edit")
          this.initializeConsole({ consoleId: queries.id, mode: "EDIT" });
        // if (params.mode === "view") this.initializeViewer(queries.id);
        // else if (params.mode === "edit") this.initializeEditor(queries.id);
      } else {
        // this.initializeEditor();
        this.initializeConsole({ mode: "EDIT" });
      }
    },
  },
  async mounted() {
    this.reset();
    const params = this.$route.params;
    const queries = this.$route.query;

    // Anything that is common for both initializeEditor and initializeViewer do it here:
    const staticConsoles = await this.fetchConsoles();
    const entityEvents = await this.fetchEntityEvents();
    // console.log(entityEvents);
    await this.fetchStaticEntities().then(() => {
      // for each static entity load the entity list
      if (this.getStaticEntities.length > 0) {
        this.getStaticEntities.forEach(async (entity, index) => {
          if (index === 0) {
            // For now, there can only be one static entity per account
            await this.setStaticEntityId(entity.id);
            await this.fetchStaticEntityList({ scaffoldImmediately: true });
          }
        });
      } else {
        // If there's no static entity, user cannot do static assets performance
        this.$router.push("/");
      }
    });

    if (staticConsoles && staticConsoles.length > 0) {
      // If multiple consoles are present(which should not happen), initialize the first console in view mode:
      const firstConsole = staticConsoles[0];

      if (queries.id != firstConsole.id) {
        // If the id doesn't matches firstConsole redirect to first console's view mode:
        this.$router.push(`/analysis/view?id=${firstConsole.id}`);
      } else {
        // Else initialize as per request:
        this.initialize({ params, queries });
      }
    } else {
      // Else initialize the edit mode (empty console):

      if (!(params.mode === "edit" && !queries.id)) {
        // If the url isn't '/analysis/edit change to it:
        this.$router.push("/analysis/edit");
      } else {
        // Else initialize as per request (/analysis/edit):
        this.initialize({ params, queries });
      }
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      // console.log({ to, from });
      const params = to.params;
      const queries = to.query;

      this.initialize({ params, queries });
    },
  },
};
</script>

<style></style>
